import React, { useContext, useState } from "react";

import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Upload,
} from "antd";
import { BaseURL } from "../../constants/enum/baseURL.emum";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import OverwriteMomentBE from "../common/datePicker/overwriteMomentBE";
import { Moment } from "moment";
import moment from "moment";
import { curriContext } from "../../pages/summary/summary";
import sumService from "../../services/sum.service";
import Swal from "sweetalert2";

const BtnSendFile = (props: {
  form: { type: string; year: string; term: string };
  curri: {
    id: number;
    level: string;
    degreeName: string;
    name: string;
    shortName: string;
  };
  typeDocTH: string;
}) => {
  const { setReCheck } = useContext<any>(curriContext);
  const { form, curri, typeDocTH } = props;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [antForm] = Form.useForm();
  const user = JSON.parse(localStorage.getItem("user") ?? "false");
  const [reportDay, setReportDay] = useState<Moment | null>(moment());

  const normFile = (e: any) => {
    // console.log("upload file:", e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  const propsUploadSummary = {
    name: "file",
    action: `${BaseURL.BASE_URL}/upload/summary/${form.type}`,
    onChange: (info: any) => {
      // console.log(info);
      return info;
    },
  };

  const onFinish = async (values: any) => {
    await sumService
      .send({
        year: values.year,
        term: values.term,
        type: form.type,
        sendBy: values.sendBy,
        pathFile: values.upload[0].response.filename,
        curriculum: curri.id,
        report: reportDay === null ? "" : reportDay.format("YYYY/MM/DD"),
      })
      .then(() => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "บันทึกสำเร็จ",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          handleClose();
          setReCheck(true);
        });
      })
      .catch(() => {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "มีความผิดพลาดบางอย่าง",
          showConfirmButton: false,
          timer: 1500,
        });
      });
    setReCheck(false);
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-outline-secondary"
        onClick={handleShow}
      >
        <i className="bi bi-cloud-arrow-up-fill"></i> ส่งแบบสรุป {typeDocTH}
      </button>
      <Modal
        visible={show}
        onCancel={handleClose}
        footer={[
          <button
            type="submit"
            className="btn btn-primary"
            onClick={antForm.submit}
          >
            เพิ่มข้อมูล
          </button>,
          <button
            type="reset"
            className="btn btn-warning ms-1"
            onClick={() => antForm.resetFields()}
          >
            ล้าง
          </button>,

          <button
            type="button"
            className="btn btn-danger ms-1"
            onClick={handleClose}
          >
            Close
          </button>,
        ]}
        // centered
      >
        <Form
          name="basic"
          form={antForm}
          initialValues={{
            year: Number(form.year),
            sendBy: `${user.firstName} ${user.lastName}`,
            checkBox: ["activitySTD"],
            term: Number(form.term),
            date: null,
          }}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Row>
            <Col span={24}>
              <p className="text-danger">
                อัพโหลดได้เฉพาะไฟล์ PDF และอัพโหลดได้เพียง 1 ไฟล์เท่านั้น
              </p>
              <Form.Item
                name="upload"
                label={`ไฟล์สรุป ${typeDocTH}`}
                valuePropName="fileList"
                getValueFromEvent={normFile}
                rules={[{ required: true, message: "upload เอกสารด้วยครับ!" }]}
              >
                <Upload {...propsUploadSummary} maxCount={1}>
                  <Button>Click to upload</Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col span={24}>
              <MuiPickersUtilsProvider utils={OverwriteMomentBE} locale="th">
                <div>
                  <label htmlFor="doc3" className="form-label">
                    วันที่รายงาน
                  </label>
                  <DatePicker
                    // id="doc3"
                    name="date"
                    className={`form-control`}
                    format="DD/MM/YYYY"
                    value={reportDay}
                    onChange={(value) => {
                      setReportDay(value);
                    }}
                  />
                </div>
              </MuiPickersUtilsProvider>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col span={8}>
              <Form.Item
                name={"year"}
                label="ปีการศึกษา"
                rules={[
                  {
                    required: true,
                    message: "กรุณาระบุปีการศึกษาด้วยครับ",
                  },

                  { type: "number", message: "กรอกเป็นตัวเลขปีเท่านั้น" },
                ]}
              >
                <InputNumber controls={false} className="col-12" />
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item
                name="term"
                label="ภาคการศึกษา"
                rules={[{ required: true }]}
              >
                <Select placeholder="เลือกภาคการศึกษา">
                  <Select.Option value={1}>ภาคเรียนที่ 1</Select.Option>
                  <Select.Option value={2}>ภาคเรียนที่ 2</Select.Option>
                  <Select.Option value={3}>ภาคเรียนที่ 3</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <label htmlFor="sendBy">ผู้ส่งเอกสาร 3</label>
              <Form.Item
                name="sendBy"
                rules={[
                  { required: true, message: "Please input your username!" },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default BtnSendFile;
